<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringPoint.meteringPointId' | translate }}</label>
    <input type="text" appInput formControlName="meteringPointIdentification" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input appInputDate formControlName="validFrom" [attr.min]="minValidFrom" [attr.max]="maxValidFrom">
  </app-input-group>

  <fieldset class="mb-4" data-testid="connection-source">
    <legend class="ec-input-label">
      {{ 'meteringPoint.action.connect.source.title' | translate }} <span class="text-red-500">*</span>
    </legend>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-1" role="radiogroup">
      <label class="source-card" [class.source-card--selected]="connectionSource === 'meter'" data-testid="source-meter">
        <input type="radio" class="sr-only" name="connectionSource" value="meter"
               [checked]="connectionSource === 'meter'"
               (change)="selectConnectionSource('meter')">
        <span class="source-card__indicator" aria-hidden="true"></span>
        <span class="flex flex-col">
          <span class="font-semibold">{{ 'meteringPoint.action.connect.source.meter' | translate }}</span>
          <span class="text-xs text-gray-500">{{ 'meteringPoint.action.connect.source.meterDescription' | translate }}</span>
        </span>
      </label>

      <label class="source-card" [class.source-card--selected]="connectionSource === 'calculation'" data-testid="source-calculation">
        <input type="radio" class="sr-only" name="connectionSource" value="calculation"
               [checked]="connectionSource === 'calculation'"
               (change)="selectConnectionSource('calculation')">
        <span class="source-card__indicator" aria-hidden="true"></span>
        <span class="flex flex-col">
          <span class="font-semibold">{{ 'meteringPoint.action.connect.source.calculation' | translate }}</span>
          <span class="text-xs text-gray-500">{{ 'meteringPoint.action.connect.source.calculationDescription' | translate }}</span>
        </span>
      </label>
    </div>

    @if (connectionSourceInvalid) {
      <div class="ec-input-error" data-testid="source-error">
        {{ 'meteringPoint.action.connect.source.required' | translate }}
      </div>
    }

    @if (currentSubtypeKey; as subtypeKey) {
      <p class="text-xs text-gray-500 mt-2" data-testid="current-subtype">
        {{ 'meteringPoint.action.connect.source.currentSubtype' | translate: { subtype: (subtypeKey | translate) } }}
      </p>
    }
  </fieldset>

  @if (connectionSource === 'meter') {
    <app-input-group>
      <label appLabel>{{ 'meteringpoint.meternumber' | translate }}</label>
      <select appSelect formControlName="meterIdentification" data-testid="meter-select">
        <option [ngValue]="null" disabled>{{ 'meteringpoint.meter.selectmeter' | translate }}</option>
        @for (item of meterList; track item.id) {
          <option [value]="item.id">{{ item | meterOptionLabel }}</option>
        }
      </select>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meteringpoint.serialnumber' | translate }}</label>
      <input type="text" appInput formControlName="meterSerialNumber" readonly>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'common.quadrant' | translate }}</label>
      <select appSelect formControlName="quadrant">
        <option [ngValue]="null" disabled>{{ 'common.quadrant' | translate }}</option>
        @for (q of quadrant; track q.key) {
          <option [value]="q.key">
            {{ q.value | translate }}@if (getRegisterForSelectedMeter(q.key); as register) { ({{ register }}) }
          </option>
        }
      </select>
    </app-input-group>
  }

  @if (connectionSource === 'calculation') {
    <app-calculation-form
      [form]="calculationForm"
      [rowHandler]="rowHandler"
      [algorithmDynamic]="algorithmDynamic">
    </app-calculation-form>
  }

  @if (connectionSource) {
    <app-alert type="info" [closeable]="false">
      {{ 'meteringPoint.action.connect.source.subtypeInfo' | translate }}
    </app-alert>
  }
</form>
